const SubscriptionEditorCancelledMsg = "Subscription editing cancelled";
const SubscriptionEditorDialogBackdropClickedMsg = "backdrop click";

class SubscriptionEditorError {
    constructor({isError, errorMessage, errorData}) {
        this.isError = isError;
        this.errorMessage = errorMessage;
        this.errorData = errorData;
    }

    static get EditorCancelledMsg() {
        return SubscriptionEditorCancelledMsg;
    }

    static get EditorDialogBackdropClickedMsg() {
        return SubscriptionEditorDialogBackdropClickedMsg;
    }
    
    static MakeEditorCancelledResult() {
        return new SubscriptionEditorError({
            isError: false,
            errorMessage: SubscriptionEditorCancelledMsg,
            errorData: null
        });
    }
}

export default SubscriptionEditorError;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/SubscriptionEditorError.js
// module id = FlxK
// module chunks = 1